import AutoFixHigh from "@mui/icons-material/AutoFixHigh";
import FileUpload from "@mui/icons-material/FileUpload";
import { Box, Button, Typography } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { HeaderBar } from "../../generic/components/header-bar";

export const ContentLibraryHeader: FC<{ onUpload: () => void }> = ({ onUpload }) => {
  const { t } = useTranslation();

  return (
    <HeaderBar navBurger>
      <Typography variant="body1" fontWeight={700} fontSize={16}>
        {t("Content Library")}
      </Typography>
      <Box>
        <Button
          onClick={onUpload}
          variant="outlined"
          color="primary"
          data-analytics-id="content-library-upload-file"
          startIcon={<FileUpload />}
          sx={{ mr: 2 }}
        >
          {t("Upload file")}
        </Button>
        <Button
          variant="contained"
          color="primary"
          href="/"
          data-analytics-id="content-library-create-content-cta"
          startIcon={<AutoFixHigh />}
        >
          {t("Create Content")}
        </Button>
      </Box>
    </HeaderBar>
  );
};
